<nav class="navbar navbar-light navbar-expand-lg ">
    <!-- Navbar content -->
    <a class="navbar-brand" [routerLink]="['/']">
        <img src="assets/img/logo.png" style="height: 50px;" />
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/']">Inicio</a>
            </li>
            <li class="nav-item">
                <a class="nav-link"(click)="scroll(empresa)" href="javascript:void(0)">Empresa</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="scroll(diferencias)" href="javascript:void(0)">Diferencias</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="scroll(acreditacion)" href="javascript:void(0)">Acreditación</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="scroll(enviarCaso)" href="javascript:void(0)">Envíe su caso</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/login']">Acceso Ortodoncista</a>
            </li>
        </ul>
    </div>
</nav>